<template>
  <div class="mobile-menu-button">
    <button class="mobile-menu-button__trigger" type="button" aria-label="打开导航菜单" @click="openMenu">
      <img class="mobile-menu-button__icon" :src="icon" alt="" />
    </button>
    <transition name="mobile-menu-drawer">
      <mobile-menu v-if="isMenuOpen" @close="closeMenu" />
    </transition>
  </div>
</template>

<script>
import MobileMenu from '@/components/navigation/MobileMenu.vue'

export default {
  name: 'MobileMenuButton',
  components: { MobileMenu },
  props: {
    icon: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isMenuOpen: false
    }
  },
  methods: {
    openMenu() {
      this.isMenuOpen = true
    },
    closeMenu() {
      this.isMenuOpen = false
    }
  }
}
</script>

<style scoped>
.mobile-menu-button {
  position: relative;
}

.mobile-menu-button__trigger {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  touch-action: manipulation;
}

.mobile-menu-button__trigger::before {
  position: absolute;
  top: 50%;
  right: 0;
  width: 44px;
  height: 44px;
  transform: translateY(-50%);
  content: '';
}

.mobile-menu-button__icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
